// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Box, CircularProgress, Paper, PaperProps } from '@mui/material';

type Props = Pick<PaperProps, 'sx'>;
/**
 * A card that contains a circular progress indicator.
 */
export function CircularProgressCard(props: Props) {
  return (
    <Paper variant="outlined" sx={props.sx}>
      <Box display="flex" justifyContent="center" padding={4}>
        <CircularProgress />
      </Box>
    </Paper>
  );
}
